export const DRAWER_WIDTH_DESKTOP = 96;
export const DRAWER_WIDTH_MOBILE = 240;

export const CTA_TYPE = {
  active_cta: 'active-cta',
  primary_cta: 'primary-cta',
  secondary_cta: 'secondary-cta',
  secondary_active_cta: 'secondary-active-cta',
  secondary_cta_with_accent: 'secondary-cta-with-accent',
};
export const CTA_SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'big',
};

export const DATE_TIME_FORMATS = {
  dayMonthYear: 'DD/MM/YYYY',
  day_month_year: 'DD-MM-YYYY',
  yearMonthDay: 'YYYY-MM-DD',
  monthYear: 'MM/YYYY',
  yearMonthDayTime: 'YYYY-MM-DD hh:mm A',
  time: 'hh:mm A',
  dayMonthYearHHMM: 'DD/MM/YYYY , hh:mm A',
  dayMonth: 'DD-MM',
  dayMonthTime: 'D MMM hh:mm A',
  hourMinute: 'hh:mm A',
  monthDayYear: 'MMM DD, YYYY',
};

export const ALL_MONTHS = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];

export const NUMBER_OF_MONTHS_IN_YEAR = 12;

export const MONTHS_NUMERIC_MAP: any = {
  JAN: '01',
  FEB: '02',
  MAR: '03',
  APR: '04',
  MAY: '05',
  JUN: '06',
  JUL: '07',
  AUG: '08',
  SEP: '09',
  OCT: '10',
  NOV: '11',
  DEC: '12',
};

export const MESSAGE_TYPE = {
  success: 'success',
  error: 'error',
  warning: 'warning',
};

//map status of branches/stores
export const BRANCH_STATUS_MAP = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};

export const COMPARE_DATES = {
  TODAY: 'Today',
  YESTERDAY: 'Yesterday',
  WEEK: 'Last Week',
  MONTH: 'Last Month',
  '3_MONTHS': 'Last 3 Months',
};

// Documement titles for different pages
export const DOCUMENT_TITLE_TYPE = {
  login: 'Login - DotPe Cappitals',
  homepage: 'DotPe Cappitals',
  businessLoanPage: 'Business Loans - DotPe Cappitals',
  personalLoanPage: 'Personal Loans - DotPe Cappitals',
  aboutUsPage: 'About Us - DotPe Cappitals',
  contactUsPage: 'Contact Us - DotPe Cappitals',
  privacyPolicyPage: 'Privacy Ploicy - DotPe Cappitals',
  termsofUsePage: 'Terms Of Use - DotPe Cappitals',
  disclaimerPage: 'Disclaimer - DotPe Cappitals',
  intellectualProperty: 'Intellectual Property - DotPe Cappitals',
  grievanceRedressal: 'Grievance Redressal - DotPe Cappitals',
  creditTnC: 'Credit Terms Of Use - DotPe Cappitals',
  experianTnC: 'Experian Terms Of Use - DotPe Cappitals',
  thankYouPage: 'Thank You - DotPe Cappitals',
  fetchCreditReport: 'Credit Report - DotPe Cappitals',
  default: 'DotPe Cappitals',
  creditReport: 'Credit Report',
  creditFAQs: 'FAQs - Credit Report',
  creditProfile: 'Profile - Credit Report',
  creditContactUs: 'Contact Us - Credit Report',
};

export const SOURCE = {
  utm_source: 'utm_source',
  utm_medium: 'utm_medium',
  utm_campaign: 'utm_campaign',
  fk_seller_id: 'fk-external_seller_id-offer_id',
};

export const APP_VERSION = 'app_version';
export const digitalShowroomAndroidAppLink =
  'https://play.google.com/store/apps/details?id=com.digitaldukaan';

export const ANDROID_FEATURE_VERSION_SUPPORT = {
  BL_KYC: '4.7.105',
};
